// Helpers for formatting location labels in the QC Data & Charts dropdowns.
//
// Locations are stored and keyed as a single "Region - Area - Laboratory" string
// (e.g. "America - Midwest - Aledo"). That full string is the value used to match
// data throughout the app, so these helpers only ever change how a location is
// *displayed* — never the underlying value.

// Extracts just the laboratory portion of a "Region - Area - Laboratory" string.
// Splits on a space-delimited hyphen or en-dash so laboratory names that contain
// their own hyphens/spaces are preserved.
export function getLaboratoryOnly(location) {
  if (!location) return '';
  const parts = String(location).split(/ [-–] /);
  return parts[parts.length - 1].trim();
}

// Builds the display label for a location dropdown option. When hideRegionArea is
// true only the laboratory portion of the name is shown; the "(count)" suffix that
// the dropdowns append is always preserved.
export function formatLocationOptionLabel(option, hideRegionArea = false) {
  const name = hideRegionArea ? getLaboratoryOnly(option.name) : option.name;
  return option.count ? `${name} (${option.count})` : `${name}`;
}

// Comparator for location dropdown options. Sorts by the label the user actually
// sees — laboratory-only when hideRegionArea is on, otherwise the full location
// string — so the visible dropdown never appears unsorted. Numeric-aware so lab
// names like "Lab 2" and "Lab 10" order naturally.
export function compareLocationOptions(a, b, hideRegionArea = false) {
  const aName = hideRegionArea ? getLaboratoryOnly(a.name) : a.name;
  const bName = hideRegionArea ? getLaboratoryOnly(b.name) : b.name;
  return String(aName).localeCompare(String(bName), undefined, { numeric: true });
}
